const Minus = () => {
  return (
    <svg width={12 * 1.5} height={3 * 1.5} viewBox="0 0 12 3" fill="none">
      <path
        d="M1 1L10.9374 1.05723"
        stroke="black"
        strokeOpacity={0.9}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Minus;
